module.exports = __webpack_public_path__ + "/images/monitorizacion-precios-wishlist-IT.cc3dace.png";